import ThemeProvider, {
  useTheme,
  useThemeFlag,
  ThemeContext,
  ERASMUSU_THEME,
  SPOTAHOME_THEME,
  LANDLORD_THEME,
  PARTNER_DEMO_THEME,
  PARTNER_RUFA_THEME,
  WGGESUCHT_THEME,
  ESTATE_TO_RENT_THEME
} from './ThemeProvider';

export default ThemeProvider;
export {
  useTheme,
  useThemeFlag,
  ThemeContext,
  ERASMUSU_THEME,
  SPOTAHOME_THEME,
  LANDLORD_THEME,
  PARTNER_DEMO_THEME,
  PARTNER_RUFA_THEME,
  WGGESUCHT_THEME,
  ESTATE_TO_RENT_THEME
};
